// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"pagesetup_flexContainer__12ssQ","overAll":"pagesetup_overAll__39w3z","tagOne":"pagesetup_tagOne__ETwml","tagTwo":"pagesetup_tagTwo__2-DVi"};